import React from 'react';
import { Dumbbell, Heart, Users, DollarSign, Gift } from 'lucide-react';
export function CaroProgramsPricing() {
  const programs = [{
    icon: Users,
    name: 'Taekwondo',
    description: 'Traditional martial arts training for all ages',
    pricing: 'First 2 weeks FREE',
    highlight: true
  }, {
    icon: Dumbbell,
    name: 'Brazilian Jiu-Jitsu',
    description: 'Ground-based grappling and self-defense',
    pricing: 'First 2 weeks FREE',
    highlight: true
  }, {
    icon: Heart,
    name: 'Zumba',
    description: 'High-energy dance fitness classes',
    pricing: '$5 drop-in',
    highlight: false
  }, {
    icon: Dumbbell,
    name: 'Aerobic Kickboxing',
    description: 'Cardio workout with martial arts techniques',
    pricing: '$5 drop-in',
    highlight: false
  }];
  return <section className="py-16 bg-slate-50" data-id="element-501">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-502">
        <div className="text-center mb-12" data-id="element-503">
          <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-504">
            Programs & Pricing
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-505">
            Choose from our variety of martial arts and fitness programs
            designed for all skill levels and interests.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-506">
          {programs.map((program, index) => <div key={index} className={`bg-white rounded-xl border-2 p-6 text-center ${program.highlight ? 'border-[#dc2626] shadow-md' : 'border-slate-200 shadow-sm'}`} data-id="element-507">
              <div className={`inline-flex items-center justify-center w-12 h-12 rounded-full mb-4 ${program.highlight ? 'bg-[#dc2626]' : 'bg-slate-900'}`} data-id="element-508">
                <program.icon className="h-6 w-6 text-white" data-id="element-509" />
              </div>
              <h3 className="text-lg font-bold text-[#1a2332] mb-2" data-id="element-510">
                {program.name}
              </h3>
              <p className="text-sm text-slate-600 mb-4" data-id="element-511">
                {program.description}
              </p>
              <div className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-bold ${program.highlight ? 'bg-[#dc2626] text-white' : 'bg-slate-100 text-slate-700'}`} data-id="element-512">
                {program.highlight && <Gift className="h-4 w-4 mr-2" data-id="element-513" />}
                {!program.highlight && <DollarSign className="h-4 w-4 mr-1" data-id="element-514" />}
                {program.pricing}
              </div>
            </div>)}
        </div>

        {/* Additional Info */}
        <div className="bg-white rounded-xl border border-slate-200 p-6 text-center" data-id="element-515">
          <p className="text-slate-600" data-id="element-516">
            <span className="font-bold text-[#1a2332]" data-id="element-517">Special Offer:</span> Get
            your first 2 weeks FREE for Taekwondo and Brazilian Jiu-Jitsu! Try
            Zumba and Aerobic Kickboxing with our convenient $5 drop-in option.
          </p>
        </div>
      </div>
    </section>;
}